import { DefaultTheme } from 'styled-components/macro';
import { theme } from '../../style';
import { commonThemeStyles } from './common';
import automotiveLogo from 'lib/images/covideodealerservices_logo.png';
import smallLogoDelaerService from 'lib/images/covideo_delaer_service_mini_logo.svg';

export const covideoAutomotiveTheme: Omit<DefaultTheme, 'setTheme'> = {
  colors: {
    navItemColor: theme.palette.covideoBlue100,
    primaryColor5: 'rgb(28, 106, 207, 0.05)',
    primaryColor10: 'rgb(28, 106, 207, 0.1)',
    primaryColor80: 'rgb(28, 106, 207, 0.8)',
    primaryColor: '#1C6ACF',
    secondaryColor5: theme.palette.blue05,
    secondaryColor: theme.palette.covideoBlue100,
    primaryButtonTextColor: theme.palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: theme.palette.white,
  },
  logos: {
    small: smallLogoDelaerService,
    normal: automotiveLogo,
  },
  ...commonThemeStyles,
};
export const covideoTheme: Omit<DefaultTheme, 'setTheme'> = {
  colors: {
    navItemColor: theme.palette.whiteRgb75,
    primaryColor5: 'rgba(255, 139, 34, 0.05)',
    primaryColor10: 'rgba(255, 139, 34, 0.1)',
    primaryColor80: 'rgba(255, 139, 34, 0.8)',
    primaryColor: '#ff8b22',
    secondaryColor5: 'rgba(255, 139, 34, 0.05)',
    secondaryColor: '#ff8b22',
    primaryButtonTextColor: theme.palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: theme.palette.primaryDarkBlue,
  },
  logos: {
    small: undefined,
    normal: undefined,
  },
  ...commonThemeStyles,
};

export const app2vidTheme: Omit<DefaultTheme, 'setTheme'> = {
  colors: {
    navItemColor: theme.palette.whiteRgb75,
    primaryColor5: 'rgb(229, 8, 126, 0.05)',
    primaryColor10: 'rgb(229, 8, 126, 0.1)',
    primaryColor80: 'rgb(229, 8, 126, 0.8)',
    primaryColor: '#E5087E',
    secondaryColor5: 'rgb(229, 8, 126, 0.05)',
    secondaryColor: '#E5087E',
    primaryButtonTextColor: theme.palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: theme.palette.primaryDarkBlue,
  },
  logos: {
    small: undefined,
    normal: undefined,
  },
  ...commonThemeStyles,
};

export const proVideoNowTheme: Omit<DefaultTheme, 'setTheme'> = {
  colors: {
    navItemColor: theme.palette.black,
    primaryColor5: 'rgb(219, 17, 32, 0.05)',
    primaryColor10: 'rgb(219, 17, 32, 0.1)',
    primaryColor80: 'rgb(219, 17, 32, 0.8)',
    primaryColor: '#DB1120',
    secondaryColor5: 'rgb(219, 17, 32, 0.05)',
    secondaryColor: '#DB1120',
    primaryButtonTextColor: theme.palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: theme.palette.primaryDarkBlue,
  },
  logos: {
    small: undefined,
    normal: undefined,
  },
  ...commonThemeStyles,
};

export const kennectedTheme: Omit<DefaultTheme, 'setTheme'> = {
  colors: {
    navItemColor: theme.palette.whiteRgb75,
    primaryColor5: 'rgb(1, 122, 32, 0.05)',
    primaryColor10: 'rgb(1, 122, 32, 0.1)',
    primaryColor80: 'rgb(1, 122, 32, 0.8)',
    primaryColor: '#017A20',
    secondaryColor5: 'rgb(1, 122, 32, 0.05)',
    secondaryColor: '#017A20',
    primaryButtonTextColor: theme.palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: theme.palette.primaryDarkBlue,
  },
  logos: {
    small: undefined,
    normal: undefined,
  },
  ...commonThemeStyles,
};

export const vidisTheme: Omit<DefaultTheme, 'setTheme'> = {
  colors: {
    navItemColor: theme.palette.whiteRgb75,
    primaryColor5: 'rgb(255, 5, 0, 0.0.5)',
    primaryColor10: 'rgb(255, 5, 0, 0.1)',
    primaryColor80: 'rgb(255, 5, 0, 0.8)',
    primaryColor: '#FF0500',
    secondaryColor5: 'rgb(255, 5, 0, 0.0.5)',
    secondaryColor: '#FF0500',
    primaryButtonTextColor: theme.palette.white,
    secondaryButtonBgColor: '#F2F4F6',
    sideBarColor: theme.palette.primaryDarkBlue,
  },
  logos: {
    small: undefined,
    normal: undefined,
  },
  ...commonThemeStyles,
};
